import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import config from '../../../../helpers/config';
import EnterAddress from './EnterAddress';
import EnterAddressTheHomeDepot from './EnterAddressTheHomeDepot';
import updateAddress from '../../../../actions/availability/updateAddress';
import loading from '../../../../actions/loading';
import loaded from '../../../../actions/loaded';
import verifiedAddress from '../../../../actions/availability/verifiedAddress';
import { sites } from '../../../../helpers/globalVariables';

const component = config.siteId !== sites.theHomeDepot ? EnterAddress : EnterAddressTheHomeDepot;

const mapStateToProps = ({ estimateBuilder }) => {
  const { address } = estimateBuilder.mandiAvailability;
  return { address };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    updateAddress, loading, loaded, verifiedAddress,
  }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(component);
